import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_sk_group_clip = _resolveComponent("v-sk-group-clip")!
  const _component_v_sk_group = _resolveComponent("v-sk-group")!

  return (_openBlock(), _createBlock(_component_v_sk_group, {
    x: _ctx.x,
    y: _ctx.y,
    color: _ctx.color,
    style: _normalizeStyle(typeof _ctx.style === 'string' ? _ctx.style : undefined),
    strokeWidth: _ctx.strokeWidth,
    invertClip: _ctx.invertClip
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_v_sk_group_clip, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "clip")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["x", "y", "color", "style", "strokeWidth", "invertClip"]))
}